//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import headMixin from '~/mixins/head.mixin'

export default {
  name: 'Sitemap',
  layout: ({ store, redirect, i18n }) => {
    if (!store.getters['landings/mainSettings'].isRussianFranchise[0]) {
      return redirect('/' + i18n.locale)
    }

    return 'sitemap'
  },
  mixins: [headMixin],
  computed: {
    ...mapState('landings', {
      preparedHead: (state) => state.preparedHead,
      domainData: (state) => state.currentDomainData,
    }),
    domains() {
      return this.$getDomains()
    },
    meta() {
      return this.preparedHead.meta.concat([
        {
          hid: 'description',
          name: 'description',
          content: this.$getTextMainSetting('description'),
        },
      ])
    },
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })

    return {
      ...this.preparedHead,
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
        dir: this.$direction(),
      },
      title: this.$getTextMainSetting('title'),
      meta: this.meta,
      link: [
        { rel: 'icon', type: 'image/x-icon', href: `/main.ico` },
        {
          rel: 'canonical',
          href: 'https://' + this.domainData.siteUrl + this.$route.path,
        },
      ],
      __dangerouslyDisableSanitizers: ['script', 'noscript'],
    }
  },
}
